/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Description_Item_3Inputs */

const es_tyc_description_item_3 = /** @type {(inputs: Tyc_Description_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox`)
};

const en_tyc_description_item_3 = /** @type {(inputs: Tyc_Description_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox`)
};

/**
* | output |
* | --- |
* | "Dropbox" |
*
* @param {Tyc_Description_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_description_item_3 = /** @type {((inputs?: Tyc_Description_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Description_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_description_item_3(inputs)
	return en_tyc_description_item_3(inputs)
});
export { tyc_description_item_3 as "tyc.description.item_3" }